<template>
  <div>
    <div class="mb-3 d-flex gap-2">
      <button class="btn btn-sm btn-outline-primary" @click="addBlock('text')">
        ➕ Добавить "Текст"
      </button>

      <button class="btn btn-sm btn-outline-success" @click="addBlock('faq')">
        ➕ Добавить "FAQ"
      </button>
    </div>

    <draggable
        v-model="blocks"
        item-key="id"
        handle=".drag-handle"
        ghost-class="drag-ghost"
        animation="200"
    >
      <template #item="{ element, index }">
        <div class="border rounded p-3 bg-white shadow-sm mb-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="drag-handle" style="cursor: grab;">☰ {{ getTypeName(element.type) }}</span>
            <button class="btn btn-sm btn-danger" @click="removeBlock(index)">
              Удалить блок
            </button>
          </div>

          <component
              :is="componentsMap[element.type]"
              :payload="element.payload"
              @onUpdate="updateBlock(index, $event)"
          />
        </div>
      </template>
    </draggable>
  </div>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue'
import draggable from 'vuedraggable'

import Text from '../text/Index'
import Faq from '../faq/Index'
import Helper from "@/services/Helper"

const emit = defineEmits(['onUpdate'])
const props = defineProps({
  payload: {type: Object, default: () => ({val: []})}
})

let counter = 0
const blocks = ref([])

const componentsMap = {text: Text, faq: Faq}

// Инициализация
onMounted(() => {
  if (!Helper.isArray(props.payload.val)) {
    return
  }

  initPayload(props.payload)
})

// PageBuilder сам не трогает data — только передает
function addBlock(type) {
  counter++

  blocks.value.push({
    id: counter,
    type,
    payload: {type, data: {}}  // компонент сам заполнит
  })
}

function removeBlock(i) {
  blocks.value.splice(i, 1)
}

function updateBlock(i, payload) {
  blocks.value[i].payload = payload
}

// Emit наружу
watch(blocks, () => {
  emit('onUpdate', blocks.value.map(b => b.payload))
}, {deep: true})

function initPayload(payload) {
  initValPayload(payload)
}

function initValPayload(payload) {
  payload.val.forEach(block => {
    counter++
    blocks.value.push({
      id: counter,
      type: block.type,
      payload: {
        type: block.type,
        data: block.data ?? {}
      }
    })
  })
}

function getTypeName(type) {
  switch (type) {
    case "text":
      return "Блок Текст"
    case "faq":
      return "Блок FAQ"
  }
}
</script>

<style scoped>
.drag-ghost {
  opacity: 0.5;
  background: #f8f9fa;
}
</style>
